import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { PROJECTS } from '../constants';
import { Project } from '../types';
import NotFound from './NotFound';

interface ProjectDetailRouteProps {
  render: (project: Project) => React.ReactNode;
}

const ProjectDetailRoute: React.FC<ProjectDetailRouteProps> = ({ render }) => {
  const params = useParams();
  const projectId = params.projectId;

  const project = useMemo(
    () => PROJECTS.find((p) => p.id === projectId),
    [projectId]
  );

  if (!project) {
    return <NotFound />;
  }

  return <>{render(project)}</>;
};

export default ProjectDetailRoute;
